/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_9f5bbbcc"]'><div><cube-button @tap='(e)=>__invoke(e, [["showActionSheet"]])'>action-sheet</cube-button><cube-action-sheet ref="__mpx_ref_actionSheet__" title="我是标题~~~" :inputData="(inputData)" @select='(e)=>__invoke(e, [["onSelect"]])'/><cube-toast :txt="(selectContent)" ref="__mpx_ref_selectToast__"></cube-toast></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_9f5bbbcc"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_9f5bbbcc"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_9f5bbbcc"}
  /** script content **/
  require("./action-sheet.mpx.js?isComponent&outputPath=components%2Faction-sheet9f5bbbcc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./action-sheet.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Faction-sheet9f5bbbcc%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_9f5bbbcc"],
    ctorType: "component",
    outputPath: "components/action-sheet9f5bbbcc/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-action-sheet':getComponent(require("../../../packages/mpx-cube-ui/src/components/action-sheet/index.mpx?isComponent&outputPath=components%2Findex51c8754f%2Findex")),'cube-toast':getComponent(require("../../../packages/mpx-cube-ui/src/components/toast/index.mpx?isComponent&outputPath=components%2Findex7b472558%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>